module.exports = __webpack_public_path__ + "static/media/newsletter-december-2023-7.545efd17.jpg";